import React from 'react';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  background?: string;
}

export default function Section({ children, className = '', background }: SectionProps) {
  return (
    <section className={`container-custom py-16 md:py-24 ${background || ''} ${className}`}>
      {children}
    </section>
  );
}